import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { PORTAL_MODE, cedentePath, partnerSubdomainUrl, loginUrl } from "../lib/portal";

export default function ProtectedRoute({ children, roles, portalType }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-[#f8f9fa]">
        <Loader2 className="h-6 w-6 animate-spin text-[#0055FF]" />
      </div>
    );
  }
  if (!user) {
    // On partner portal, redirect to unified login on clientes.*
    if (PORTAL_MODE === "partner") {
      window.location.href = loginUrl();
      return null;
    }
    return <Navigate to="/login" replace />;
  }
  // Partner user on cedente portal → bounce to parceiros.*
  if (portalType === "cedente" && user.portal_type !== "cedente") {
    const url = partnerSubdomainUrl("/dashboard");
    if (url) {
      window.location.href = url;
      return null;
    }
    return <Navigate to="/dashboard" replace />;
  }
  // Cedente user on partner portal → bounce to clientes.*
  if (portalType === "partner" && user.portal_type !== "partner") {
    if (PORTAL_MODE === "partner") {
      window.location.href = `https://clientes.zemocapital.com/operacoes`;
      return null;
    }
    return <Navigate to={cedentePath("/operacoes")} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    const fallback =
      user.portal_type === "cedente" ? cedentePath("/operacoes") : "/dashboard";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
